function cov_2oefn8tspw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Filter.tsx";
  var hash = "7b40cd7f2b7e9eb8c4537511de6f2a5fd1ab4b66";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b40cd7f2b7e9eb8c4537511de6f2a5fd1ab4b66"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2oefn8tspw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2oefn8tspw();
var Icon = (cov_2oefn8tspw().s[0]++, {
  name: 'filter',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11 17.75C10.7875 17.75 10.6094 17.6781 10.4656 17.5343C10.3219 17.3904 10.25 17.2122 10.25 16.9997C10.25 16.7871 10.3219 16.609 10.4656 16.4654C10.6094 16.3218 10.7875 16.25 11 16.25H13C13.2125 16.25 13.3906 16.3219 13.5344 16.4657C13.6781 16.6095 13.75 16.7877 13.75 17.0003C13.75 17.2129 13.6781 17.391 13.5344 17.5346C13.3906 17.6782 13.2125 17.75 13 17.75H11ZM3.99997 7.36533C3.78747 7.36533 3.60936 7.29342 3.46563 7.14961C3.32188 7.00579 3.25 6.82759 3.25 6.61501C3.25 6.40241 3.32188 6.22431 3.46563 6.08073C3.60936 5.93715 3.78747 5.86536 3.99997 5.86536H20C20.2125 5.86536 20.3906 5.93727 20.5344 6.08108C20.6781 6.22488 20.75 6.40308 20.75 6.61568C20.75 6.82826 20.6781 7.00635 20.5344 7.14993C20.3906 7.29353 20.2125 7.36533 20 7.36533H3.99997ZM6.99998 12.5576C6.78748 12.5576 6.60936 12.4857 6.46563 12.3419C6.32188 12.1981 6.25 12.0199 6.25 11.8073C6.25 11.5947 6.32188 11.4166 6.46563 11.2731C6.60936 11.1295 6.78748 11.0577 6.99998 11.0577H17C17.2125 11.0577 17.3906 11.1296 17.5344 11.2734C17.6781 11.4172 17.75 11.5954 17.75 11.808C17.75 12.0206 17.6781 12.1987 17.5344 12.3423C17.3906 12.4858 17.2125 12.5576 17 12.5576H6.99998Z\" fill=\"#currentColor\"/>"
});
export default Icon;